module.exports = __webpack_public_path__ + "media/mail/ulysses-ad90cbbe.png";